;; Copyright (C) 2019, 2022, Doctor Evidence. All rights reserved.

(ns dre.shared.interface.semgroups
  "Semantic groups."
  {:authors ["Jozef Wagner"]}
  (:require #?(:clj [dre.csv-util :refer [load-colls-csv]])
            #?(:cljs [dre.config :as config])))


(def semgroup-fname
  "cp:SemGroups.txt")

(defonce semgroup-label
  #?(:clj
     (let [coll (load-colls-csv semgroup-fname false :delimiter \|)
           mf (fn [[group-id group-label _ _]]
                [group-id group-label])]
       (into {} (map mf coll)))
     :cljs (fn [] (if (fn? config/semgroup-label) (config/semgroup-label) config/semgroup-label))))

#?(:clj
   (defonce tui->semgroup
     (let [coll (load-colls-csv semgroup-fname false :delimiter \|)
           mf (fn [[group-id _ tui _]]
                [tui group-id])]
       (into {} (map mf coll)))))

#?(:clj
   (defonce tui->label
     (let [coll (load-colls-csv semgroup-fname false :delimiter \|)
           mf (fn [[_ _ tui label]]
                [tui label])]
       (into {} (map mf coll)))))
